
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// Components
import BaseComponent from '../../../../baseClasses/BaseComponent';
import Checkoff from '../TaskCompletionSteps/Checkoff';
import Inspection from '../TaskCompletionSteps/Inspection';
import PhotoUpload from '../TaskCompletionSteps/PhotoUpload';
import MiscUpload from '../TaskCompletionSteps/MiscUpload';
import FormUpload from '../../../../components/Forms/FormUpload';
// Utils
import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';
import dataModel from '../../../../models/DataModel';
import DataSource from '../../../../dao/DataSource/DataSource';
import { completion_criteria_root } from '../../../../dao/CompletionCriteriaDAO';

import './TaskCompletionStepInfo.scss';

/**
 * Completion step info for WEB
 * TODO: collapse this with <TaskCompletionStepInfoMobile>
 */
export class TaskCompletionStepInfo extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      stepState: '',
    };
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: true,
    });
  }

  handleCommentsButton() {
    this.props.history.push(
      `/mobile/projects-tasks/task/${this.props.task.id}/completion_step/${
        this.props.completionStep.id
      }/comments`
    );
  }

  fixExtension(extension) {
    if (extension) {
      let markStart = extension.indexOf('?');
      if (markStart >= 0) {
        extension = extension.substring(0, markStart);
      }
    }
    return extension;
  }

  handleUpdateCompletionStep(completionStep, action, acData) {
    this.setState({ completionStep });
  }

  handleUpdateTask(task) {
    this.setState({ task });
  }
  
  componentDidMount() {
    const { completionStep, task } = this.props;
    this.csDataSource = new DataSource('CompletionCriterion', completionStep.id, completion_criteria_root, this.handleUpdateCompletionStep);
    this.csDataSource.get();

    this.taskDataSource = new DataSource('Task', task.id, { task: {} }, this.handleUpdateTask);
    this.taskDataSource.get();
  }

  componentWillUnmount() {
    if (this.csDataSource) {
      this.csDataSource.release();
      this.csDataSource = null;
    }
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
  }

  createDisplayComponent() {
    const { 
      editing, 
      project, 
      userStepPermissions, 
    } = this.props;

    const { completionStep, task } = this.state;

    let typeImage = null;
    if (completionStep.completion_type == 'boolean') {
      typeImage = (
        <Checkoff
          completionStep={completionStep}
          editing={editing}
          projectTemplate={this.props.projectTemplate}
          task={task}
          userStepPermissions={userStepPermissions}
          permissions={this.props.permissions}
          dataModel={dataModel}
          handleCommentsButton={this.handleCommentsButton}
        />
      );
    }
    else if (completionStep.completion_type == 'inspection') {
      typeImage = (
        <Inspection
          completionStep={completionStep}
          editing={editing}
          projectTemplate={this.props.projectTemplate}
          task={task}
          userStepPermissions={userStepPermissions}
          permissions={this.props.permissions}
          dataModel={dataModel}
          handleCommentsButton={this.handleCommentsButton}
          status={this.props.status}
        />
      );
    }
    else if (completionStep.completion_type == 'form') {
      typeImage = (
        <FormUpload
        projectTemplate={this.props.projectTemplate}
        completionStep={completionStep}
          userStepPermissions={userStepPermissions}
          isMobile={false}
          task={task}
          currentUser={this.props.currentUser}
        />
      );
    }
    else switch (completionStep.requested_file_type) {
    case 'png':
    case 'jpeg':
    case 'jpg':
    case 'gif':
      typeImage = (
          <PhotoUpload
            project={project}
            projectTemplate={this.props.projectTemplate}
            task={task}
            status={this.props.status}
            completionStep={completionStep}
            handleCommentsButton={this.handleCommentsButton}
            userStepPermissions={userStepPermissions}
          />
        );
      break;
    case 'doc':
    case 'docx':
    case 'dotx':
    case 'dot':
    case 'dotm':
        // TODO: collapse <MiscUpload> web/mobile components
      typeImage = (
          <MiscUpload
            userStepPermissions={userStepPermissions}
            project={project}
            projectTemplate={this.props.projectTemplate}
            task={task}
            completionStep={completionStep}
            handleCommentsButton={this.handleCommentsButton}
          />
        );
      break;
    case 'pdf':
      typeImage = (
          <MiscUpload
            userStepPermissions={userStepPermissions}
            project={project}
            projectTemplate={this.props.projectTemplate}
            task={task}
            completionStep={completionStep}
            handleCommentsButton={this.handleCommentsButton}
          />
        );
      break;
    case 'xls':
    case 'xlt':
    case 'xlm':
    case 'xlsm':
    case 'xlsx':
    case 'xltx':
      typeImage = (
          <MiscUpload
            userStepPermissions={userStepPermissions}
            project={project}
            projectTemplate={this.props.projectTemplate}
            task={task}
            completionStep={completionStep}
            handleCommentsButton={this.handleCommentsButton}
          />
        );
      break;
    case 'mp4':
    case 'mov':
    case 'avi':
    case 'wmv':
    case 'flv':
      typeImage = (
          <MiscUpload
            userStepPermissions={userStepPermissions}
            project={project}
            projectTemplate={this.props.projectTemplate}
            task={task}
            completionStep={completionStep}
            handleCommentsButton={this.handleCommentsButton}
          />
        );
      break;
    case 'Other':
      typeImage = (
          <MiscUpload
            userStepPermissions={userStepPermissions}
            project={project}
            projectTemplate={this.props.projectTemplate}
            task={task}
            completionStep={completionStep}
            handleCommentsButton={this.handleCommentsButton}
          />
        );
      break;
    default:
      typeImage = (
          <MiscUpload
            userStepPermissions={userStepPermissions}
            project={project}
            projectTemplate={this.props.projectTemplate}
            task={task}
            completionStep={completionStep}
            handleCommentsButton={this.handleCommentsButton}
          />
        );
      break;
    }
    return typeImage;
  }

  render() {
    const { task, completionStep } = this.state;
    if (!task || !completionStep) {
      return null;
    }

    return (
      <div className={'shared-task-completion-step-info '} id={this.props.id}>
        {this.createDisplayComponent()}
      </div>
    );
  }
}

;

const mapStateToProps = (state, ownProps) => {
  return {
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

// For handling state change from a dispatch
export default connect(mapStateToProps, null)(
  withRouter(TaskCompletionStepInfo)
);



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskCompletionStepsContainer/TaskCompletionStepInfo/index.js